import { jsx as _jsx } from "react/jsx-runtime";
import Container from "@mui/material/Container";
const TrombinoscopeTemplate = (props) => {
    const { page } = props;
    const { contents } = page;
    const { dynamicPart } = contents;
    return (_jsx(Container, { sx: { maxWidth: "1208px !important", py: { xs: "40px", md: "64px" } }, children: dynamicPart }));
};
export default TrombinoscopeTemplate;
